import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VRow,{attrs:{"dense":""}},[_vm._l((_vm.variations),function(variation){return [_c(VCol,{key:variation.uuid,attrs:{"cols":"12"}},[_c('VariationItem',_vm._g({attrs:{"variation":variation,"selected-variations":_vm.selectedVariations,"multiple":_vm.isMultipleSelect,"max-variations-reached":_vm.maxVariationsReached}},_vm.$listeners))],1)]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }